import React from 'react';
import { HomeButton } from '../components/HomeButton';
import { getRequest, postRequest } from '../api';
import { LoadingSpinner } from '../components/Loading';

interface SignUpReq_t {
  firstName: string,
  lastName: string,
  email: string,
  reason: string,
}

async function submitSignup(req: SignUpReq_t) {
  // TODO does Axios retry?
  await postRequest("/signup", req, {});
}

// https://stackoverflow.com/a/201378/32079877
function validateEmail(email: string): boolean {
  const regex = /(?:[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+(?:\.[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9\x2d]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return regex.test(email);
}

export const SignupPage: React.FC<{}> = () => {

  React.useEffect(() => {
    getRequest("/heartbeat", {});
    postRequest("/heartbeat", {}, {});
  }, []);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [submitted, setSubmitted] = React.useState<boolean>(false);

  const [firstName, setFirstName] = React.useState<string>("");
  const [lastName, setLastName] = React.useState<string>("");
  const [email, setEmail] = React.useState<string>("");
  const [reason, setReason] = React.useState<string>("");

  // Simple validation to disable button if required fields are empty
  const isFormValid = firstName.length && lastName.length && email.length && !loading;

  const emailLabel: string = email.length === 0 ? "Email" : (validateEmail(email) ? "Email ✅" : "Email ❌");
  const form = (
    <div className="form-group" style={{ paddingTop: "64px" }}>
      <label>First Name</label>
      <input
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        required
        disabled={loading}
      />

      <label>Last Name</label>
      <input
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        required
        disabled={loading}
      />

      <label>{emailLabel}</label>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        disabled={loading}
      />

      <label>Why are you interested in trying our search product? (optional)</label>
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        disabled={loading}
      />
      <button
        disabled={!isFormValid}
        onClick={async () => {
          setLoading(true);
          await submitSignup({ firstName, lastName, email, reason });
          setLoading(false);
          setSubmitted(true);
        }}
      >
        Submit
      </button>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: '20px'
      }}>
        {loading && <LoadingSpinner />}
      </div>
    </div>);

  const thankYouMessage = (
    <div>
      Thanks for your interest. We'll be in touch.
    </div>
  );

  return (
    <div className='App-no-center'>
      <HomeButton />
      <h1>Sign Up for the Beta</h1>
      {submitted ? thankYouMessage : form}
    </div>
  );
};